import React from 'react';
import { HiringPlanResponse } from 'clients/manager/interfaces/hiring-plans.interfaces';
import PcaItemView from './pca-item-view';

interface PcaItemProps extends HiringPlanResponse {}

const PcaItem: React.FC<PcaItemProps> = (props) => <PcaItemView {...props} />;

export default PcaItem;
